import { combineReducers, configureStore } from '@reduxjs/toolkit';

import appReducer from '@/redux/app/appSlice';
import contactsReducer from '@/redux/contacts/contactsSlice';
import ratesReducer from '@/redux/rates/ratesSlice';
import featuresReducer from '@/redux/features/featuresSlice';
import discountReducer from '@/redux/discount/discountSlice';
import feedbackReducer from '@/redux/feedback/feedbackSlice';
import faqReducer from '@/redux/faq/faqSlice';
import glossaryReducer from '@/redux/glossary/glossarySlice';
import rebateReducer from '@/redux/rebate/rebateSlice';
import ratingReducer from '@/redux/rating/ratingSlice';
import manualsReducer from '@/redux/manuals/manualsSlice';
import coursesReducer from '@/redux/courses/coursesSlice';
import partnersReducer from '@/redux/partners/partnersSlice';
import monitoringReducer from '@/redux/monitoring/monitoringSlice';

const rootReducer = combineReducers({
  app: appReducer,
  contacts: contactsReducer,
  rates: ratesReducer,
  features: featuresReducer,
  discount: discountReducer,
  feedback: feedbackReducer,
  faq: faqReducer,
  glossary: glossaryReducer,
  rebate: rebateReducer,
  rating: ratingReducer,
  manuals: manualsReducer,
  courses: coursesReducer,
  partners: partnersReducer,
  monitoring: monitoringReducer,
});

const customizedMiddleware = getDefaultMiddleware =>
  getDefaultMiddleware({ serializableCheck: false });

const store = configureStore({
  reducer: rootReducer,
  middleware: customizedMiddleware,
  devTools: import.meta.env.VITE_NODE_ENV === 'development',
});

export default store;
